import registerCustomElement from './helpers/registerCustomElement';

document.addEventListener('turbo:load', () => {
  registerCustomElement(require.context('custom-elements', true, /-element\.(js|ts)$/));

  // Packages from https://github.com/Ambiki/ambiki-packages
  import('@ambiki/clippy-copy-element');
  import('@ambiki/auto-complete-element');
});
